import FormattedPrice from "../FormattedPrice";
import styles from "./index.css";
import PropTypes from "prop-types";
import content from "app-content";

const OriginalPriceExtended = ({ originalPrice, discount, isOutlet }) => (
  <span className={styles.originalPrice}>
    <span>
      {isOutlet ? content.generic_price_rrp : content.was_pricing_label}
    </span>
    <FormattedPrice value={originalPrice} />
    <span className={styles.discounted}>{`(-${discount}%)`}</span>
  </span>
);

OriginalPriceExtended.propTypes = {
  originalPrice: PropTypes.number,
  discount: PropTypes.number.isRequired,
  isOutlet: PropTypes.bool.isRequired,
  Prefix: PropTypes.elementType.isRequired
};

export default OriginalPriceExtended;
